export const social = {
  line: 'https://lin.ee/rDPOpFj',
  fb: 'https://www.facebook.com/Step1ne/',
  ig: 'https://www.instagram.com/step1ne_tw/',
  linkedin:
    'https://www.linkedin.com/company/step1ne/posts/?feedView=all&viewAsMember=true',
};
